import { IconButton } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton";
import { FilterSelect } from "app/components/FilterSelect";
import { ThreedotIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  selectManufacturerModelLicensingWeightFilter,
  selectManufacturerModelManufacturerFilter,
  selectManufacturerModelMasterModelFilter,
  selectManufacturerModelYearFilter,
} from "../../redux/selector";
import { manufacturerModelActions } from "../../redux/slice";
import {
  ManufacturerModelLicensingWeightFilter,
  ManufacturerModelManufacturerFilter,
  ManufacturerModelMasterModelFilter,
  ManufacturerModelYearFilter,
} from "../../types";
import { useStyles } from "./styles";

type Props = {
  onAddClick?: () => void;
};

const MANUFACTURER_OPTIONS: ManufacturerModelManufacturerFilter[] = ["ALL"];
const MASTER_MODEL_OPTIONS: ManufacturerModelMasterModelFilter[] = ["ALL"];
const YEAR_OPTIONS: ManufacturerModelYearFilter[] = ["ALL"];
const LICENSING_WEIGHT_OPTIONS: ManufacturerModelLicensingWeightFilter[] = [
  "ALL",
];

const ActionBar = ({ onAddClick }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  const manufacturerFilter = useSelector(
    selectManufacturerModelManufacturerFilter
  );
  const masterModelFilter = useSelector(selectManufacturerModelMasterModelFilter);
  const yearFilter = useSelector(selectManufacturerModelYearFilter);
  const licensingWeightFilter = useSelector(
    selectManufacturerModelLicensingWeightFilter
  );

  const getAllLabel = () => t("MANUFACTURER_MODELS.FILTERS.ALL");

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton
          label={t("MANUFACTURER_MODELS.ACTIONS.ADD_MODEL")}
          onClick={onAddClick}
        />
        <IconButton size="small" className={styles.iconButton}>
          <ThreedotIcon />
        </IconButton>
      </div>

      <div className={styles.filters}>
        <FilterSelect
          label={t("MANUFACTURER_MODELS.FILTERS.LICENSING_WEIGHT.LABEL")}
          value={licensingWeightFilter}
          options={LICENSING_WEIGHT_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(manufacturerModelActions.setLicensingWeightFilter(value))
          }
        />
        <FilterSelect
          label={t("MANUFACTURER_MODELS.FILTERS.YEAR.LABEL")}
          value={yearFilter}
          options={YEAR_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(manufacturerModelActions.setYearFilter(value))
          }
        />
        <FilterSelect
          label={t("MANUFACTURER_MODELS.FILTERS.MASTER_MODEL.LABEL")}
          value={masterModelFilter}
          options={MASTER_MODEL_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(manufacturerModelActions.setMasterModelFilter(value))
          }
        />
        <FilterSelect
          label={t("MANUFACTURER_MODELS.FILTERS.MANUFACTURER.LABEL")}
          value={manufacturerFilter}
          options={MANUFACTURER_OPTIONS}
          getOptionLabel={getAllLabel}
          onChange={(value) =>
            dispatch(manufacturerModelActions.setManufacturerFilter(value))
          }
        />
      </div>
    </div>
  );
};

export default ActionBar;
